import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import Theme from "./Theme/Theme";
import NetworkStatus from "./constants/NetworkStatusBanner";
// import typography from './core/typography';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <ThemeProvider theme={Theme}>
  <>
    <NetworkStatus />
    <App />
  </>
  // </ThemeProvider>
);

reportWebVitals();
